import React from 'react'
import Modal from '../Modal'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../redux/configuration/selectors'
import '../../styles/scss/components/booking-modify/booking-modify.scss'
import './ExistingReservationForm.scss'

const ExistingReservationForm = ({
  bookingDetails,
  onModify,
  onCancel,
  onClose,
  isOpen
}) => {
  const labels = useSelector(selectLabels)

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="existing-reservation-modal u-container"
    >
      <div className="existing-reservation">
        <h2>Reservation Found</h2>
        <button className="close-reservation" onClick={onClose}>
          {labels.close} X
        </button>
        <p className="existing-reservation-details">
          Reservation ID: {bookingDetails?.bookingNumber}
        </p>
        {!bookingDetails?.canCancelBooking &&
          !bookingDetails?.canEditBooking && (
            <p className="u-text-center">
              {labels.bookingUneditable ||
                'This booking can not be cancelled or modified online.'}
            </p>
          )}
        <div className="buttons">
          {bookingDetails?.canEditBooking && (
            <button
              className="btn btn-primary wider bold center-self submit-btn"
              onClick={onModify}
            >
              Modify Booking
            </button>
          )}
          {bookingDetails?.canCancelBooking && (
            <button
              className="btn btn-primary wider bold center-self submit-btn"
              onClick={onCancel}
            >
              Cancel Booking
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ExistingReservationForm
